module.exports = __webpack_public_path__ + "images/category_lp/jewel/banner_4c94e0b497d39700b6a24ef3554c78a4.png";